// extracted by mini-css-extract-plugin
module.exports = {"ReactionButton":"MessageReactions_ReactionButton__BEamg","ReactionEmoji":"MessageReactions_ReactionEmoji__zLTi1","ReactionCount":"MessageReactions_ReactionCount__ZW5MI"};